"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// * spacing unit
var _default = exports["default"] = {
  CONTAINER: {
    XS: 4,
    SM: 5,
    LG: 6,
    XL: 11
  },
  GRID: {
    XS: 2,
    SM: 4,
    MD: 3
  }
};